// extracted by mini-css-extract-plugin
module.exports = {"actionBoxContainer":"FeatureComingSoon_actionBoxContainer_1tGpa"};